import LoadingContent from 'components/LoadingContent';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { instance } from 'services/api';
import './styles.css';
import { useCollections } from 'Providers/CollectionsProviders';
import { Button } from 'primereact/button';
import { useSessionStorageInternal } from 'Providers/SessionStorageProvider';
import isEmpty from 'lodash/isEmpty';

const ResolutionView = ({ eventData }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const preference_id = searchParams.get('preference_id');
  const PayerID = searchParams.get('PayerID');
  const token = searchParams.get('token');
  const [payment, setPayment] = useState(null);
  const {
    clearShoppingCart,
    setOrderPaymentInCurse,
    fetchCollectionsFromService,
  } = useCollections();
  const [storedValue, setStoredValue, minutesLeft, secondsLeft, reset] =
    useSessionStorageInternal();

  const [userCancelOrder, setUserCancelOrder] = useState(null);

  const goToShoppingCart = () => {
    navigate(`/shopping_cart`);
  };

  const goToHome = () => {
    navigate(`/`);
  };

  const deleteOrdenPaymentInCurse = async () => {
    if (storedValue?.preferenceId) {
      setLoading(true);
      await instance
        .post('/api/order_payment_delete', {
          preferenceId: storedValue.preferenceId,
        })
        .then((res) => {
          if (res?.data?.ok) {
            setOrderPaymentInCurse(null);
            reset();
          }
        })
        .catch((err) => console.log({ err }));
      setLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    const getPayment = async () => {
      try {
        if (isMounted && !isEmpty(preference_id)) {
          const response = await instance.get(
            `api/get_payment?preference_id=${preference_id}`,
          );
          if (response.data.ok) {
            if (response.data.payment.has_payed) {
              clearShoppingCart();
              setOrderPaymentInCurse(null);
              reset();
            }
            setPayment({
              id: response.data.payment.id,
              status: response.data.payment.has_payed ? 'COMPLETED' : 'PENDING',
              source: 'mercadolibre',
            });
          }
        }

        if (isMounted && !isEmpty(PayerID) && !isEmpty(token)) {
          const response = await instance.get(
            `/api/orders?PayerID=${PayerID}&token=${token}`,
          );

          if (response.data) {
            if (response.data.status === 'COMPLETED') {
              clearShoppingCart();
              setOrderPaymentInCurse(null);
              reset();
              fetchCollectionsFromService();
            }

            const paymentData = {
              id: response.data.orderID || token,
              status: response.data.status,
              source: 'paypal',
            };
            if (response.data.purchase_units) {
              const capture =
                response.data.purchase_units[0].payments.captures[0];
              paymentData.amount = capture.amount.value;
              paymentData.currency = capture.amount.currency_code;
              paymentData.payer = response.data.payer;
            } else if (response.data.message) {
              paymentData.message = response.data.message;
            }

            setPayment(paymentData);
          }
        } else {
          if (isEmpty(PayerID) && !isEmpty(token)) {
            deleteOrdenPaymentInCurse();
            setUserCancelOrder(true);
          }
        }
      } catch (error) {
        console.error('Error procesando el pago:', error);
      }
    };

    getPayment();

    return () => {
      isMounted = false;
    };
  }, []);

  if (userCancelOrder) {
    return (
      <div
        className="containerResult"
        style={{
          minHeight: eventData.height * 0.65,
          minWidth: eventData.width * 0.7,
        }}
      >
        <div className="circle-error">
          <i className="pi pi-times-circle icon-error" />
        </div>
        <div style={{ fontSize: '1.2em', fontWeight: 600, paddingLeft: 4 }}>
          Orden de pago cancelada
        </div>
        <div style={{ fontWeight: 600, paddingLeft: 4 }}>
          La orden de pago ha sido cancelada por el usuario, volve a intentar
          realizando otra vez.
        </div>
        <Button
          onClick={goToShoppingCart}
          style={{ marginTop: 16 }}
          label="Ir al carrito "
          severity="success"
          raised
        />
      </div>
    );
  }

  if (!payment || loading) {
    return <LoadingContent minHeight={eventData.height * 0.65} />;
  }

  return (
    <div
      className="containerResult"
      style={{
        minHeight: eventData.height * 0.65,
        minWidth: eventData.width * 0.7,
      }}
    >
      <div className="resumenContainer">
        <div className="circle-check">
          <i className="pi pi-check-circle icon-check" />
        </div>
        <div style={{ fontSize: '1.2em', fontWeight: 600 }}>
          {payment.status === 'COMPLETED'
            ? payment.message || 'Tu compra se ha realizado satisfactoriamente.'
            : 'Tu pago está siendo procesado.'}
        </div>
        {!!payment?.id && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div>{`Número de transacción:`}</div>
            <div
              style={{ fontWeight: 600, paddingLeft: 4 }}
            >{`${payment.id}`}</div>
          </div>
        )}
        {payment.source === 'paypal' && payment.payer && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: '10px',
            }}
          >
            <div>Comprador:</div>
            <div style={{ fontWeight: 600, paddingLeft: 4 }}>
              {`${payment.payer.name.given_name} ${payment.payer.name.surname}`}
            </div>
          </div>
        )}
        <div className="gratitude">
          <div>Muchas gracias por apoyar mi arte.</div>
          <div>Estaré contactándote a la brevedad.</div>
        </div>
        <Button
          onClick={goToHome}
          style={{ marginTop: 32, fontSize: '0.8em' }}
          label="Volver a la galería"
          severity="info"
          raised
        />
      </div>
    </div>
  );
};

export default ResolutionView;
